
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ad-studio/launch",
      function () {
        return require("private-next-pages/ad-studio/launch.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ad-studio/launch"])
      });
    }
  